import angular from 'angular';

window.WB = window.WB || {};

window.WB.locale = navigator.languages ? navigator.languages[0] : navigator.userLanguage;
window.WB.locale = window.locale.toLowerCase();

window.WB.Configuration = angular.module('WB.Configuration', []);
window.WB.Ext = angular.module('WB.Ext', ['WB.Configuration']);
window.WB.Core = angular.module('WB.Core', ['WB.Configuration', 'WB.Ext']);
window.WB.Forecasts = angular.module('WB.Forecasts', ['WB.Core']);
window.WB.Alerts = angular.module('WB.Alerts', ['WB.Core']);
window.WB.Maps = angular.module('WB.Maps', ['WB.Core']);
window.WB.Life = angular.module('WB.Life', ['WB.Core']);
window.WB.Media = angular.module('WB.Media', ['WB.Core']);
window.WB.Index = angular.module('WB.Index', ['WB.Core']);

window.WB.App = angular.module('WB.App', [
    'ngRoute',
    'WB.Core',
    'WB.Forecasts',
    'WB.Alerts',
    'WB.Maps',
    'WB.Life',
    'WB.Media',
    'WB.Index',
    'ngLocale',
    'react'
]);

window.WB.Configuration.constant('_Config', window._config);
window.WB.Configuration.constant('_CMSPageConfig', window._CMSPageConfig);
window.WB.App.constant('_User', window._User);
window.WB.App.constant('_AppData', window._AppData);
window.WB.App.constant('_Metadata', window._Metadata);

window.WB.App.run(['_Config', '_User', '$rootScope', 'PathHelper', '$location', '$route', 'SnowskiDataManager', 'Metadata', 'MetadataDataManager',  function(_Config, _User, $rootScope, PathHelper, $location, $route, SnowskiDataManager, Metadata, MetadataDataManager)
{
    window.injectNgDeps({ _Config: _Config, user: _User, rootScope: $rootScope, pathHelper: PathHelper, $location, $route, snowskiDataManager: SnowskiDataManager, metadata: Metadata, metadataDataManager: MetadataDataManager });
}]);
